import "./styles.scss";
import React, { useState, useEffect, useRef } from "react";
import {
	Col,
	Container,
	Row,
	Card,
	CardBody,
	CardText,
	Badge,
	BreadcrumbItem,
	Media,
	CardImg,
} from "reactstrap";
import "assets/scss/website/app.scss";
import compoundImg from "assets/images/bg.png";
import testImage from "assets/images/search.png";
import { appendData } from "store/Mode/actions";
import { MetaTags } from "react-meta-tags";
import "react-rangeslider/lib/index.css";
import { Link } from "react-router-dom";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import Slider from "./Slider";
import CompoundService from "services/Website/CompoundService";
import { SuccessOk } from "configs/statusCode";
import { useSelector, useDispatch } from "react-redux";
import MyMap from "components/Common/google-map/MyMap";
import InteractiveMode from "./InteractiveMode";
import InterActiveModeService from "services/Admin/InterActiveModeService";
import developerdImg from "assets/images/developer_logo.png";
import { useTranslation } from "react-i18next";
import http from "services/HttpService";
import Skeleton from "components/Website/Skeleton";
import SideFilters from "./SideFilters";
import TopFilter from "./TopFilters";
import UnitCard from "./UnitCard";
import CardComponent from "./CardCompound";
// import InfiniteScroll from 'react-infinite-scroll-component';
import InfiniteScroll from "react-infinite-scroller";
import { appendFilters } from "../../../store/filter/actions";
import Spinner from "components/Website/Spinner";
import Spinner2 from "components/Website/Spinner2";
import AlbumModal from "./Modal/AlbumModal";
import CallModal from "./Modal/CallModal";
import MessageModal from "./Modal/MessageModal";
import ErrorModal from "./Modal/ErrorModal";
import DeveloperModal from "./Modal/DeveloperModal";

const CompoundDetails = (props) => {
	const { t } = useTranslation();
	const dispatch = useDispatch();
	const AuthData = useSelector((state) => state.Auth);
	const modeData = useSelector((state) => state.Mode);
	const [hasMore, setHasMore] = useState(true);
	const [modal, setModal] = useState(false);
	const [albumModal, setAlbumModal] = useState(false);
	const [developerModal, setDeveloperModal] = useState(false);
	const [showHighlight, setshowHighlight] = useState(false);
	const [compound, setCompound] = useState(null);
	const [units, setUnits] = useState([]);
	const [allUnits, setAllUnits] = useState([]);
	const [intractiveUnits, setIntractiveUnits] = useState([]);
	const [loadingInteractive, setLoadingIntractive] = useState(false);
	const [loadedMasterImg, setLoadedMasterImg] = useState(false);
	const [carouselUnits, setCarouselUnits] = useState([]);
	const [unitTypes, setUnitTypes] = useState([]);
	const [errorModal, setErrorModal] = useState(false);
	const filterData = useSelector((state) => state.filter);
	const currency = useSelector((state) => state.Auth?.currency);
	const [filtersParams, setFilterParams] = useState(null);
	const [topFilterError, setTopFilterError] = useState(false);
	const [showInteractive, setShowInteractive] = useState(false);
	const [isFulllScreenState, setIsFullScreenState] = useState(true);
	const isFulllScreen = useRef(false);
	const [items, setItems] = useState([]);
	const { id } = props.match.params;
	const compoundService = new CompoundService();
	const [mapRender, setMapRender] = useState(0);
	const [loading, setLoading] = useState(false);
	const [loadingShowMore, setLoadingShowMore] = useState(false);
	const [fullScreen, setFullScreen] = useState(false);
	const [DetailsLoading, setDetailsLoading] = useState(true);
	const [totalPages, setTotalPages] = useState(0);
	const [totalUnits, setTotalUnits] = useState(0);
	const [callModal, setCallModal] = useState(false);
	const [messageModal, setMessageModal] = useState(false);

	const updateLocationPositions = (lat, lng) => {
		setCompound({ ...compound, ...{ lat, lng } });
	};

	useEffect(() => {
		setLoading(true);
		compoundService?.getCompoundSpecifications(id).then((response) => {
			if (response && response.status === SuccessOk) {
				dispatch(
					appendFilters({
						// budgetRange: (response.data.minBudget !== 0 && response.data.maxBudget !== 0) ? (response.data.minBudget == response.data.maxBudget || !response.data.minBudget) ? [1, response.data.maxBudget] : [response.data.minBudget, response.data.maxBudget] : 0,
						// budget: (response.data.minBudget !== 0 && response.data.maxBudget !== 0) ? (response.data.minBudget == response.data.maxBudget || !response.data.minBudget) ? [1, response.data.maxBudget] : [response.data.minBudget, response.data.maxBudget] : 0,
						// sizeRange: (response.data.minSize !== 0 && response.data.maxSize !== 0) ? (response.data.minSize == response.data.maxSize || !response.data.minSize) ? [1, parseFloat(response.data.maxSize)] : [parseFloat(response.data.minSize), parseFloat(response.data.maxSize)] : 0,
						// size: (response.data.minSize !== 0 && response.data.maxSize !== 0) ? (response.data.minSize == response.data.maxSize || !response.data.minSize) ? [1, parseFloat(response.data.maxSize)] : [parseFloat(response.data.minSize), parseFloat(response.data.maxSize)] : 0,
						budgetRange:
							(response.data.minBudget == 0 && response.data.maxBudget == 0) ||
							response.data.minBudget == response.data.maxBudget
								? [0, 0]
								: [
										!parseInt(response.data.minBudget)
											? 0
											: parseInt(response.data.minBudget),
										parseInt(response.data.maxBudget),
								  ],
						budget:
							(response.data.minBudget == 0 && response.data.maxBudget == 0) ||
							response.data.minBudget == response.data.maxBudget
								? 0
								: [
										!parseInt(response.data.minBudget)
											? 0
											: parseInt(response.data.minBudget),
										parseInt(response.data.maxBudget),
								  ],
						sizeRange:
							(response.data.minSize == 0 && response.data.maxSize == 0) ||
							response.data.minSize == response.data.maxSize
								? [0, 0]
								: [
										!parseInt(response.data.minSize)
											? 0
											: parseInt(response.data.minSize),
										parseInt(response.data.maxSize),
								  ],
						size:
							(response.data.minSize == 0 && response.data.maxSize == 0) ||
							response.data.minSize == response.data.maxSize
								? 0
								: [
										!parseInt(response.data.minSize)
											? 0
											: parseInt(response.data.minSize),
										parseInt(response.data.maxSize),
								  ],
						bathroomsRange:
							parseInt(response.data.minBathrooms) !==
							parseInt(response.data.maxBathrooms)
								? [
										parseInt(response.data.minBathrooms),
										parseInt(response.data.maxBathrooms),
								  ]
								: [parseInt(response.data.minBathrooms)],
						bedroomsRange:
							parseInt(response.data.minBedrooms) !==
							parseInt(response.data.maxBedrooms)
								? [
										parseInt(response.data.minBedrooms),
										parseInt(response.data.maxBedrooms),
								  ]
								: [parseInt(response.data.minBedrooms)],
						floorRange:
							parseInt(response.data.minFloor) !==
							parseInt(response.data.maxFloor)
								? [
										parseInt(response.data.minFloor),
										parseInt(response.data.maxFloor),
								  ]
								: [parseInt(response.data.minFloor)],
						CategortiesOptions: response.data.categories?.map((type) => {
							return {
								name: type?.name,
								value: type?.id,
								label: type?.name[AuthData?.lang],
							};
						}),
						page: 1,
						finishingOptions: response.data.finishing_types,
						unitTypeOptions: response.data.unit_types?.map((type) => {
							return {
								name: type?.name,
								value: type?.id,
								label: type?.name[AuthData?.lang],
							};
						}),
						getRanges: true,
					})
				);
			}
			setLoading(false);
		});
	}, [id]);

	useEffect(() => {
		setLoading(true);
		// if (filterData.unit?.length) document.getElementById("propertyNamme").blur()
		let params = {};
		if (filterData.unit?.trim().length)
			params["unit_name"] = filterData.unit.trim();
		if (filterData.budget?.length)
			params["budget"] = `${Math.round(filterData?.budget[0])}-${Math.round(
				filterData?.budget[1]
			)}`;
		if (filterData.size?.length)
			params["area_sizs"] = `${Math.round(filterData?.size[0])}-${Math.round(
				filterData?.size[1]
			)}`;
		if (filterData.floor?.length) params["floors"] = filterData.floor.join();
		if (filterData.bedrooms?.length)
			params["bedrooms"] = filterData.bedrooms.join();
		if (filterData.bathrooms?.length)
			params["bathrooms"] = filterData.bathrooms.join();
		if (filterData.paymentMethods?.length)
			params["payment_type"] = filterData.paymentMethods.join();
		if (filterData.categories_ids?.length)
			params["category_ids"] = formatParamsHandler(filterData.categories_ids);
		if (filterData.finishingType?.length)
			params["finishing_type_ids"] = formatParamsHandler(
				filterData.finishingType
			);
		if (filterData.unitType?.length)
			params["unit_type_ids"] = formatParamsHandler(filterData.unitType);

		if (filterData?.getRanges) {
			setFilterParams({ ...params });
			setLoading(false);
		}
	}, [filterData]);

	const isExist = (arr, id) => {
		const element = arr?.find((item) => {
			return item.id === id;
		});
		if (element) {
			return true;
		} else {
			return false;
		}
	};

	// FullScreenElement
	useEffect(() => {
		document.addEventListener("fullscreenchange", () => {
			// document.fullscreenElement will point to the element that
			// is in fullscreen mode if there is one. If there isn't one,
			// the value of the property is null.
			if (document.fullscreenElement) {
				isFulllScreen.current = true;
				setIsFullScreenState(true);
				// document.body.style.overflow = 'hidden';
			} else {
				isFulllScreen.current = false;
				setIsFullScreenState(false);
				setFullScreen(false);
				document.body.style.overflow = "scroll";
			}
			// isFulllScreen.current=!isFulllScreenState
		});
	}, []);

	// useEffect(()=>{
	//     setIntractiveUnits([])
	// },[filterData.unitType, filterData.finishingType, filterData.categories_ids, filterData.paymentMethods,
	//    filterData.bathrooms, filterData.bedrooms, filterData.floor, filterData.size, filterData.budget, filterData.unit])

	useEffect(() => {
		if (!!filtersParams && filterData.getRanges) {
			const types = [];
			http.setLang();
			setLoading(true);
			let params = {
				...filtersParams,
				// per_page: filterData.per_page, page: filterData.page
			};

			compoundService.find(id, { ...params }).then((response) => {
				if (response && response.status === SuccessOk) {
					setCompound({ ...response.data.compound });
					response.data.units?.data.forEach((unit, index) => {
						if (!isExist(types, unit.unit_type.id)) {
							types.push(unit.unit_type);
						}
					});
					setUnitTypes([...types]);
					if (filterData.page == 1) {
						setUnits([...response.data.units.data]);
						setAllUnits([...response.data.units.data]);
					} else {
						setAllUnits((data) => [...data, ...response.data.units.data]);
					}
					setTotalPages(
						Math.ceil(response.data.units.meta.total / filterData.per_page)
					);
					if (
						!!Number(response.data.compound.lang) &&
						!!Number(response.data.compound.lat)
					)
						setMapRender(mapRender + 1);
					setLoading(false);
					setDetailsLoading(false);
					setLoadingShowMore(false);
					if (
						[...allUnits, ...response.data.units.data]?.length <
						response?.data?.units?.meta?.total
					) {
						setHasMore(true);
					} else {
						setHasMore(false);
					}
					if (
						!filterData.unitType?.length &&
						!filterData.finishingType?.length &&
						!filterData.categories_ids?.length &&
						!filterData.floor?.length &&
						!filterData.bedrooms?.length &&
						!filterData.bathrooms?.length
					) {
						setTotalUnits(response?.data?.units?.meta?.total);
					}
				}
			});
		}
	}, [filtersParams]);

	const getAllUnits = () => {
		setLoadingIntractive(true);
		compoundService
			.find(id, {
				budget: filtersParams.budget,
				area_sizs: filtersParams.area_sizs,
				per_page: totalUnits,
			})
			.then((response) => {
				if (response && response.status === SuccessOk) {
					setIntractiveUnits([...response.data.units.data]);
					setShowInteractive(true);
					setLoadingIntractive(false);
				}
			});
	};

	useEffect(() => {
		let unitsArray = units.map((item, index) => index < 11 && item);
		unitsArray.push({});
		setCarouselUnits(unitsArray);
	}, [units]);

	useEffect(async () => {
		if (id) {
			new InterActiveModeService().getInteractiveModeSite(id).then((res) => {
				if (res?.data?.length) {
					const data = res.data[0];
					const master = data?.images?.find(
						(item) => item?.image?.id === data?.main_image?.id
					);
					dispatch(
						appendData({
							compound: modeData.compound,
							currentImge: {
								id: master?.image?.id,
								path: master?.imagepath,
							},
							masterImg: {
								id: master?.image?.id,
								path: master?.image?.path,
							},
							images: res.data[0]?.images?.map((img) => ({
								...img,
								...img?.image,
								image: null,
							})),
						})
					);
				}
			});
		}
	}, [id]);

	useEffect(() => {
		const data = compound?.images?.map((img, index) => {
			return {
				src: img.path,
				altText: `Slide ${index + 1}`,
				caption: `Slide ${index + 1}`,
			};
		});
		setItems(data);
	}, [compound]);

	// useEffect(() => {
	//     if (isFulllScreenState) {
	//         document.getElementById("canvas").scrollIntoView()
	//         //  disableBodyScroll()
	//         setTimeout(() => {
	//             document.body.style.overflow = 'hidden';
	//         }, [1000])
	//     } else {
	//         // enableBodyScroll()
	//     }
	//     // return () => {
	//     //   clearAllBodyScrollLocks();
	//     // };

	// }, [isFulllScreenState])

	const toggleFullscreen = () => {
		if (
			!document.fullscreenElement &&
			/* alternative standard method */ !document.mozFullScreenElement &&
			!document.webkitFullscreenElement
		) {
			// current working methods
			setFullScreen(true);
			if (document.documentElement.requestFullscreen) {
				document.documentElement.requestFullscreen();
			} else if (document.documentElement.mozRequestFullScreen) {
				document.documentElement.mozRequestFullScreen();
			} else if (document.documentElement.webkitRequestFullscreen) {
				document.documentElement.webkitRequestFullscreen(
					Element.ALLOW_KEYBOARD_INPUT
				);
			}
		} else {
			setFullScreen(false);
			if (document.cancelFullScreen) {
				document.cancelFullScreen();
			} else if (document.mozCancelFullScreen) {
				document.mozCancelFullScreen();
			} else if (document.webkitCancelFullScreen) {
				document.webkitCancelFullScreen();
			}
		}
	};

	useEffect(() => window.scrollTo({ left: 0, behavior: "smooth" }), []);

	if (DetailsLoading) {
		// if (true) {
		return <Skeleton.CompoundDetails history={props.history} />;
	}

	const fetchMoreData = () => {
		setLoadingShowMore(true);
		if (filterData.page + 1 <= totalPages) {
			dispatch(appendFilters({ page: filterData.page + 1 }));
		}
	};

	return (
		<div className="websitPages compound-details pt-10rem details">
			<MetaTags>
				<title>{t("Compound details Page")}</title>
			</MetaTags>
			<div>
				<Container fluid className="px-lg-5 pb-5 px-3">
					{/* <ol className="breadcrumb ps-0 mb-2">
						<BreadcrumbItem>
							<Link to="/">{t("home")}</Link>
						</BreadcrumbItem>
						<BreadcrumbItem
							style={{ cursor: "pointer" }}
							onClick={() => {
								props.history.goBack();
							}}>
							{t("results")}
						</BreadcrumbItem>
						<BreadcrumbItem active>{t("details")}</BreadcrumbItem>
					</ol> */}
					<Row className="new-projects-search gap-3 gap-md-0">
						<Col md={2}>
							<div className="search-icon" onClick={() => setModal(true)}>
								<svg
									width="22"
									height="20"
									viewBox="0 0 22 20"
									fill="none"
									xmlns="http://www.w3.org/2000/svg">
									<path
										d="M16 3C16 2.40666 16.1759 1.82664 16.5056 1.33329C16.8352 0.839943 17.3038 0.455426 17.8519 0.228363C18.4001 0.00129986 19.0033 -0.0581102 19.5853 0.0576455C20.1672 0.173401 20.7018 0.459124 21.1213 0.878681C21.5409 1.29824 21.8266 1.83279 21.9424 2.41473C22.0581 2.99667 21.9987 3.59987 21.7716 4.14805C21.5446 4.69623 21.1601 5.16477 20.6667 5.49441C20.1734 5.82406 19.5933 6 19 6C18.2044 6 17.4413 5.68393 16.8787 5.12132C16.3161 4.55871 16 3.79565 16 3ZM1 4H13C13.2652 4 13.5196 3.89464 13.7071 3.70711C13.8946 3.51957 14 3.26522 14 3C14 2.73479 13.8946 2.48043 13.7071 2.2929C13.5196 2.10536 13.2652 2 13 2H1C0.734784 2 0.48043 2.10536 0.292893 2.2929C0.105357 2.48043 0 2.73479 0 3C0 3.26522 0.105357 3.51957 0.292893 3.70711C0.48043 3.89464 0.734784 4 1 4ZM7 7C6.38106 7.00174 5.7778 7.19488 5.27293 7.55294C4.76807 7.911 4.38631 8.41645 4.18 9H1C0.734784 9 0.48043 9.10536 0.292893 9.2929C0.105357 9.48043 0 9.73479 0 10C0 10.2652 0.105357 10.5196 0.292893 10.7071C0.48043 10.8946 0.734784 11 1 11H4.18C4.36345 11.5189 4.6861 11.9773 5.11264 12.3251C5.53918 12.6729 6.05317 12.8966 6.59836 12.9718C7.14355 13.0471 7.69893 12.9709 8.20371 12.7516C8.70849 12.5323 9.14323 12.1784 9.46035 11.7286C9.77746 11.2788 9.96473 10.7504 10.0017 10.2013C10.0386 9.65219 9.92376 9.1035 9.66973 8.61528C9.41571 8.12706 9.03227 7.71812 8.5614 7.43323C8.09052 7.14833 7.55035 6.99846 7 7ZM21 9H13C12.7348 9 12.4804 9.10536 12.2929 9.2929C12.1054 9.48043 12 9.73479 12 10C12 10.2652 12.1054 10.5196 12.2929 10.7071C12.4804 10.8946 12.7348 11 13 11H21C21.2652 11 21.5196 10.8946 21.7071 10.7071C21.8946 10.5196 22 10.2652 22 10C22 9.73479 21.8946 9.48043 21.7071 9.2929C21.5196 9.10536 21.2652 9 21 9ZM9 16H1C0.734784 16 0.48043 16.1054 0.292893 16.2929C0.105357 16.4804 0 16.7348 0 17C0 17.2652 0.105357 17.5196 0.292893 17.7071C0.48043 17.8946 0.734784 18 1 18H9C9.26522 18 9.51957 17.8946 9.70711 17.7071C9.89464 17.5196 10 17.2652 10 17C10 16.7348 9.89464 16.4804 9.70711 16.2929C9.51957 16.1054 9.26522 16 9 16ZM21 16H17.82C17.5841 15.3328 17.1199 14.7704 16.5095 14.4124C15.8991 14.0543 15.1818 13.9235 14.4843 14.0432C13.7868 14.1629 13.154 14.5253 12.6979 15.0663C12.2418 15.6074 11.9916 16.2923 11.9916 17C11.9916 17.7077 12.2418 18.3926 12.6979 18.9337C13.154 19.4747 13.7868 19.8371 14.4843 19.9568C15.1818 20.0765 15.8991 19.9457 16.5095 19.5876C17.1199 19.2296 17.5841 18.6672 17.82 18H21C21.2652 18 21.5196 17.8946 21.7071 17.7071C21.8946 17.5196 22 17.2652 22 17C22 16.7348 21.8946 16.4804 21.7071 16.2929C21.5196 16.1054 21.2652 16 21 16Z"
										fill="#A19D9E"
									/>
								</svg>
								<span>{t("filter")}</span>
							</div>
						</Col>
						<Col md={10}>
							<div className="search-input">
								<input
									type="text"
									placeholder="Search by area, Compound"
									// value={newProjectSearch}
									id="compoundNamme"
									// onChange={(e) => setNewProjectSearch(e.target?.value)}
								/>
								<svg
									width="24"
									height="24"
									viewBox="0 0 24 24"
									fill="none"
									xmlns="http://www.w3.org/2000/svg">
									<g clip-path="url(#clip0_345_1335)">
										<path
											d="M23.7075 22.293L17.7615 16.347C19.1735 14.622 20.0225 12.419 20.0225 10.022C20.0215 4.508 15.5355 0.0209961 10.0215 0.0209961C4.50748 0.0209961 0.0214844 4.508 0.0214844 10.021C0.0214844 15.534 4.50748 20.021 10.0215 20.021C12.4195 20.021 14.6225 19.172 16.3465 17.76L22.2925 23.706C22.4875 23.901 22.7435 23.999 22.9995 23.999C23.2555 23.999 23.5115 23.901 23.7065 23.706C24.0975 23.315 24.0975 22.683 23.7065 22.292L23.7075 22.293ZM13.5355 12.535L11.7145 14.316C11.2415 14.779 10.6215 15.009 10.0005 15.009C9.37949 15.009 8.75949 14.779 8.28549 14.316L6.47349 12.543C5.52149 11.592 5.00048 10.336 5.00048 9C5.00048 7.664 5.52149 6.408 6.46549 5.465C7.40849 4.521 8.66449 4 10.0005 4C11.3365 4 12.5915 4.521 13.5355 5.465C14.4795 6.409 15.0005 7.664 15.0005 9C15.0005 10.336 14.4795 11.592 13.5355 12.535ZM10.0005 6C9.19849 6 8.44549 6.312 7.88049 6.879C7.31349 7.445 7.00049 8.198 7.00049 9C7.00049 9.802 7.31249 10.555 7.87949 11.121L9.68449 12.887C9.85849 13.057 10.1425 13.057 10.3165 12.887L12.1295 11.114C12.6885 10.555 13.0005 9.802 13.0005 9.001C13.0005 8.2 12.6875 7.446 12.1215 6.88C11.5555 6.314 10.8015 6 10.0005 6ZM10.0005 9.993C9.44849 9.993 9.00049 9.545 9.00049 8.993C9.00049 8.441 9.44849 7.993 10.0005 7.993C10.5525 7.993 11.0005 8.441 11.0005 8.993C11.0005 9.545 10.5525 9.993 10.0005 9.993Z"
											fill="#A19D9E"
										/>
									</g>
									<defs>
										<clipPath id="clip0_345_1335">
											<rect width="24" height="24" fill="white" />
										</clipPath>
									</defs>
								</svg>
							</div>
						</Col>
					</Row>
					<div className="position-relative">
						<div className="sideFilters-compound">
							{modal && (
								<SideFilters
									id={id}
									loading={loading}
									setLoading={setLoading}
									type="Unit"
									modal={modal}
									setModal={setModal}
								/>
							)}
						</div>
						<div>
							<p
								className="page-title"
								dangerouslySetInnerHTML={{
									__html: t("compound details title"),
								}}></p>
							<Row className="compounds-images gap-3 gap-md-0">
								{items && items?.length >= 1 && (
									<Col md={3}>
										<img
											src={items[0]?.src}
											alt={items[0]?.altText}
											onClick={() => setAlbumModal(true)}
											className="w-100 first-col"
										/>
									</Col>
								)}
								{items && items?.length >= 2 && (
									<Col md={3}>
										{items?.length >= 2 && (
											<img
												src={items[1]?.src}
												alt={items[1]?.altText}
												onClick={() => setAlbumModal(true)}
												className="w-100 second-col first"
											/>
										)}
										{items?.length >= 3 && (
											<img
												src={items[2]?.src}
												alt={items[2]?.altText}
												onClick={() => setAlbumModal(true)}
												className="w-100 second-col second"
											/>
										)}
									</Col>
								)}
								{items && items?.length >= 4 && (
									<Col md={3}>
										<img
											src={items[3]?.src}
											alt={items[3]?.altText}
											onClick={() => setAlbumModal(true)}
											className="w-100 first-col"
										/>
									</Col>
								)}
								{items && items?.length >= 5 && (
									<Col md={3}>
										{items?.length >= 5 && (
											<img
												src={items[4]?.src}
												alt={items[4]?.altText}
												onClick={() => setAlbumModal(true)}
												className="w-100 second-col second"
											/>
										)}
										{items?.length >= 6 && (
											<div className="last" onClick={() => setAlbumModal(true)}>
												<img
													src={items[5]?.src}
													alt={items[5]?.altText}
													className="w-100 second-col"
												/>
											</div>
										)}
									</Col>
								)}
								{albumModal && (
									<AlbumModal
										albumModal={albumModal}
										setAlbumModal={setAlbumModal}
										images={items}
									/>
								)}
								{compound && compound?.images.length === 0 && (
									<Row>
										<Col md={12}>
											<img src={compoundImg} className="img-responsive2" />
										</Col>
									</Row>
								)}
							</Row>
							<Row className="mt-5">
								<Col lg={9} md={6}>
									<div className="d-flex gap-2">
										{compound?.developer?.media?.path ? (
											<img
												src={compound.developer.media.path}
												width="100"
												height="100"
												style={{ borderRadius: "25px" }}
											/>
										) : (
											<img
												src={developerdImg}
												height="100"
												width="100"
												style={{ borderRadius: "25px" }}
											/>
										)}
										<div>
											<p className="fw-bold mb-0 text-color font-size-24">
												{compound?.name[`${AuthData.lang}`]
													? compound?.name[`${AuthData.lang}`]
													: compound?.name?.en}
											</p>
											<p className="text-color font-size-14 mb-0">
												{" "}
												{compound?.address[`${AuthData.lang}`]
													? compound?.address[`${AuthData.lang}`]
													: compound?.address?.en}{" "}
												,
												{compound?.area?.name[`${AuthData.lang}`]
													? compound?.area?.name[`${AuthData.lang}`]
													: compound?.area?.name?.en}{" "}
												,
												{compound?.city?.name[`${AuthData.lang}`]
													? compound?.city?.name[`${AuthData.lang}`]
													: compound?.city?.name?.en}
											</p>
											<p className="text-primary font-size-14 mb-0">
												{compound?.installment
													? t("up to installment", {
															num: compound?.installment,
													  })
													: t("only cash")}
											</p>
											<p className="text-color font-size-14 mb-0">
												{t("starting from")}{" "}
												<span className="fw-bold">
													{compound && toCurrency(compound.starting_from)}{" "}
													{compound && currency?.currency_code}
												</span>
											</p>
										</div>
									</div>
								</Col>
								<Col lg={3} md={6}>
									<div
										className="text-center p-2"
										style={{
											boxShadow: `rgba(0, 0, 0, 0.1) 0 7px 15px`,
											borderRadius: "25px",
										}}>
										<p
											style={{ cursor: "pointer" }}
											className="text-primary m-0 font-size-14"
											onClick={() => setDeveloperModal(true)}>
											{t("Developer overview")}
										</p>
									</div>
									<div
										className="mt-3 rounded-4 p-3 text-center"
										style={{ background: "var(--bg-color)" }}>
										<p className="text-primary font-size-14 mb-1">
											{t("Contact Us")}
										</p>
										<div className="d-flex justify-content-between mt-2 gap-2">
											<button
												onClick={() => setCallModal(true)}
												className="d-flex gap-2 rounded-4 w-100 justify-content-center px-3 py-2 align-items-center border-0 text-white"
												style={{
													background: "var(--primary-color)",
													fontSize: "10px",
												}}>
												<i className="fa fa-phone" /> {t("call")}
											</button>
											<button
												onClick={() => setMessageModal(true)}
												className="d-flex gap-2 rounded-4 w-100 justify-content-center px-3 py-2 align-items-center border-0 text-white"
												style={{
													background: "var(--primary-color)",
													fontSize: "10px",
												}}>
												<i className="fa fa-envelope" /> {t("Message")}
											</button>
										</div>
									</div>
								</Col>
							</Row>
							{/* {AuthData.lang &&
										unitTypes?.map((unit, index) => {
											return (
												<Badge
													key={index}
													className="custom-badge font-size-12">
													{unit?.name[`${AuthData.lang}`]
														? unit?.name[`${AuthData.lang}`]
														: unit?.name?.en}
												</Badge>
											);
										})} */}
							<div className="mt-5">
								<p className="font-size-32 fw-bold text-primary mb-2">
									<span className="bask-font">{t("About")}</span>{" "}
									{compound?.name[`${AuthData.lang}`]
										? compound?.name[`${AuthData.lang}`]
										: compound?.name?.en}
								</p>
								<CardText tag="p" className="font-size-16 m-0">
									{compound?.description[`${AuthData.lang}`]
										? compound?.description[`${AuthData.lang}`]
										: compound?.description?.en}
								</CardText>
							</div>
							<div className="mt-5">
								<CardText tag="h3" className="text-primary py-2 fw-bold ">
									{t("compound amenities")}
								</CardText>
								<Row>
									{compound &&
										compound.facilities?.map((item, index) => {
											return (
												<Col xl={3} lg={3} md={4} key={index}>
													<div className="mt-2">
														<div
															className="text-center p-3"
															style={{
																border: "1px solid var(--primary-color)",
																borderRadius: "30px",
															}}>
															<CardText className="font-size-16 fw-bold text-primary">
																{item?.name[`${AuthData.lang}`]
																	? item?.name[`${AuthData.lang}`]
																	: item?.name?.en}
															</CardText>
														</div>
													</div>
												</Col>
											);
										})}
								</Row>
							</div>
						</div>
					</div>

					{/* Videos */}
					{compound && compound.videos?.length !== 0 && (
						<div>
							<Carousel
								className="pb-3 mb-4"
								swipeable={true}
								draggable={true}
								showDots={true}
								responsive={videoResponsive}
								infinite={false}
								autoPlaySpeed={1000}
								keyBoardControl={true}
								customTransition="all .5"
								transitionDuration={500}
								customRightArrow={<CustomRight />}
								customLeftArrow={<CustomLeft />}
								containerClass="carousel-container w-100 videos-carousel"
								removeArrowOnDeviceType={[]}
								dotListClass="custom-dot-list-style"
								itemClass="carousel-item-padding-40-px">
								{compound?.videos?.map((video, index) => {
									return (
										<video key={index} controls>
											<source src={video?.path} type="video/mp4" />
										</video>
									);
								})}
							</Carousel>
						</div>
					)}

					{/* Matching Units */}
					<div className="mt-4" dir={AuthData.lang === "ar" ? "rtl" : "ltr"}>
						<CardText
							tag="h3"
							className="font-size-24 text-primary mb-2 fw-bold mt-5">
							{t("matching units")}
						</CardText>
						{units?.length > 0 ? (
							<Carousel
								className="pb-3 mb-4"
								swipeable={true}
								draggable={true}
								showDots={true}
								responsive={responsive}
								infinite={false}
								autoPlaySpeed={1000}
								keyBoardControl={true}
								customTransition="all .5"
								transitionDuration={500}
								customRightArrow={<CustomRight />}
								customLeftArrow={<CustomLeft />}
								containerClass="carousel-container"
								removeArrowOnDeviceType={[]}
								dotListClass="custom-dot-list-style"
								itemClass="carousel-item-padding-40-px">
								{allUnits.map((unit, index) => {
									if (index < 11) {
										return (
											<UnitCard
												item={{
													...unit,
													city: compound.city,
													area: compound.area,
													address: compound.address,
													length: units?.length,
												}}
												index={index}
												key={index}
												history={props.history}
											/>
										);
									}
								})}
								<a href="#interactive" className="underlinedText">
									<Card className="comCard mb-4 overflow-hidden">
										<CardImg src={testImage}></CardImg>
										<CardBody className="text-center pt-5">
											<div className="maxBodyHeightNew">
												<p
													className="text-primary"
													// style={{
													// 	fontWeight: 800,
													// 	fontSize: "16px",
													// 	position: "absolute",
													// 	bottom: "66%",
													// 	left: "50%",
													// 	transform: "translate(-50%, -50%)",
													// }}
												>
													<i className="fas me-1 fa-search"></i>{" "}
													{t("Explore more")}
												</p>
											</div>
										</CardBody>
									</Card>
								</a>
							</Carousel>
						) : (
							<p className="font-size-16 px-2 ">{t("no match units")}</p>
						)}
					</div>

					{/* Location */}
					{!!mapRender && (
						<div>
							<h3 className="text-primary mb-2 bask-font font-size-32">
								{t("location")}
							</h3>
							<div>
								<MyMap
									updateLocationPositions={updateLocationPositions}
									lat={compound.lat}
									lng={compound.lang}
								/>
							</div>
						</div>
					)}

					{/* Interactive */}
					<div className="pb-3 mt-5">
						<p className="text-primary font-size-24 mb-1 fw-bold mt-4">
							{t("Buy your Unit Inside Project")}
						</p>
						<span className="mt-1 my-2 font-size-16 text-primary">
							{t("interactive subtitle")}
						</span>
						<TopFilter
							topFilterError={topFilterError}
							setTopFilterError={setTopFilterError}
							id={id}
							loading={loading}
							setLoading={setLoading}
							type="Unit"
						/>

						<p className="text-primary font-size-24 mb-1 fw-bold mt-3">
							{t("Interactive Mode")}
						</p>
						<span className="mt-1 my-2 font-size-16 text-primary">
							{t(
								"Kindly Drag, scroll, and pin to explore and compare detailed unit information."
							)}
						</span>
						<Row className="mt-3 gap-4 gap-md-0">
							<Col md="6">
								<div
									className="newShadow p-md-5 p-2"
									style={{
										height: "30rem",
										background: "#fcdcca",
									}}>
									<div className="h-100 overflow-hidden">
										<div className="h-100 overflow-scroll">
											<div>
												<InfiniteScroll
													pageStart={0}
													hasMore={true}
													useWindow={false}
													loadMore={() => {}}
													loader={
														filterData.page + 1 <= totalPages &&
														!loadingShowMore && (
															<div
																className="loader font-size-14 text-primary text-center"
																onClick={() => fetchMoreData()}>
																See More
															</div>
														)
													}>
													{allUnits.map((unit, index) => (
														<CardComponent
															key={index}
															item={unit}
															history={props.history}
														/>
													))}
												</InfiniteScroll>
												{loadingShowMore && (
													<div className="position-relative pt-2 pb-2">
														<Spinner2></Spinner2>
													</div>
												)}
											</div>
										</div>
									</div>
								</div>
							</Col>
							<Col md="6">
								<div className="position-relative newShadow">
									{modeData?.masterImg?.path ? (
										<div
											id="interactive"
											className="position-relative"
											style={{ height: "30rem", objectFit: "cover" }}>
											<div className="shape-container">
												<div
													className="mouse_container-web"
													onClick={() => {
														if (
															filterData.unitType?.length == 0 &&
															filterData.finishingType.length == 0 &&
															filterData.categories_ids.length == 0 &&
															filterData.floor.length == 0 &&
															filterData.bedrooms.length == 0 &&
															filterData.bathrooms.length == 0
														) {
															setTopFilterError(true);
															setErrorModal(true);
															window.scrollTo({
																top: 1950, //1540
																left: 0,
																behavior: "smooth",
															});
														} else {
															if (intractiveUnits?.length == 0) {
																getAllUnits();
															} else if (
																!loadingInteractive &&
																loadedMasterImg
															) {
																document.body.style.overflow = "hidden";
																setShowInteractive(true);
															}
														}
													}}>
													{loadingInteractive ? (
														<Spinner2></Spinner2>
													) : (
														<>
															<i className="fas fa-mouse-pointer fa-3x text-white"></i>
															<span className="d-block fw-bold font-size-32 bask-font text-white text-center">
																Drag and Scroll
															</span>
														</>
													)}
												</div>
											</div>
											<img
												style={{
													borderRadius: "25px",
													padding: 0,
													width: "100%",
													height: "100%",
												}}
												onClick={() => {
													setshowHighlight(true);
													setTimeout(() => {
														setshowHighlight(false);
													}, 250);
												}}
												onLoad={() => {
													if (!loadingInteractive && showInteractive) {
														document.body.style.overflow = "hidden";
														setShowInteractive(true);
													}
													setLoadedMasterImg(true);
												}}
												src={modeData?.masterImg?.path}
											/>
										</div>
									) : (
										<div
											style={{
												height: "30rem",
											}}
											className="position-relative">
											<h4
												style={{
													position: "absolute",
													top: "50%",
													left: "30%",
													background: "var(--primary-color)",
													color: "#fff",
													borderRadius: "25px",
													padding: "16px 32px",
													transform: "translate(-20%, -50%)",
												}}>
												Interactive mode hasn't been added yet
											</h4>
										</div>
									)}
								</div>
							</Col>
						</Row>
						{!loadingInteractive &&
							showInteractive &&
							intractiveUnits?.length > 0 && (
								<InteractiveMode
									developer={compound?.developer}
									allUnits={intractiveUnits}
									city={compound?.city?.name}
									setFullScreen={setFullScreen}
									setShowInteractive={setShowInteractive}
									address={compound?.address}
									history={props.history}
									compound={compound}
									area={compound?.area?.name}
								/>
							)}
					</div>
				</Container>
			</div>

			{callModal && (
				<CallModal
					modal={callModal}
					setModal={setCallModal}
					phone={compound?.sales_rep?.phone}
				/>
			)}
			{messageModal && (
				<MessageModal
					modal={messageModal}
					setModal={setMessageModal}
					item={compound?.sales_rep}
					type="compound"
				/>
			)}
			{developerModal && (
				<DeveloperModal
					modal={developerModal}
					setModal={setDeveloperModal}
					developer={compound?.developer}
				/>
			)}
			{errorModal && <ErrorModal modal={errorModal} setModal={setErrorModal} />}
		</div>
	);
};

const CustomRight = ({ onClick }) => (
	<button onClick={onClick} className="arrow right border-0">
		<i className="fas fa-arrow-right fa-1x"></i>
	</button>
);
const CustomLeft = ({ onClick }) => (
	<button onClick={onClick} className="arrow left border-0">
		<i className="fas fa-arrow-left fa-1x"></i>
	</button>
);
const toCurrency = (number) => {
	const formatter = new Intl.NumberFormat("en-US");
	return formatter.format(number);
};

const responsive = {
	superLargeDesktop: {
		// the naming can be any, depends on you.
		breakpoint: { max: 4000, min: 3000 },
		items: 4,
		slidesToSlide: 3,
	},
	desktopLg: {
		breakpoint: { max: 3000, min: 1300 },
		items: 4,
		slidesToSlide: 3,
	},
	desktop: {
		breakpoint: { max: 1300, min: 1100 },
		items: 4,
		slidesToSlide: 3,
	},
	tablet: {
		breakpoint: { max: 1100, min: 600 },
		items: 2,
		slidesToSlide: 2,
	},
	mobile: {
		breakpoint: { max: 600, min: 0 },
		items: 1,
		slidesToSlide: 1,
	},
};
const videoResponsive = {
	superLargeDesktop: {
		// the naming can be any, depends on you.
		breakpoint: { max: 4000, min: 3000 },
		items: 1,
		slidesToSlide: 1,
	},
	desktopLg: {
		breakpoint: { max: 3000, min: 1300 },
		items: 1,
		slidesToSlide: 1,
	},
	desktop: {
		breakpoint: { max: 1300, min: 1100 },
		items: 1,
		slidesToSlide: 1,
	},
	tablet: {
		breakpoint: { max: 1100, min: 600 },
		items: 1,
		slidesToSlide: 1,
	},
	mobile: {
		breakpoint: { max: 600, min: 0 },
		items: 1,
		slidesToSlide: 1,
	},
};
const formatParamsHandler = (data) => {
	let value = "";
	for (let i = 0; i < data.length; i++) {
		if (i === 0) {
			value = data[i].id ?? data[i].value;
		} else {
			value = `${value},${data[i].id ?? data[i].value}`;
		}
	}
	return value;
};
const options = {
	year: "numeric",
	month: "short",
};

export default CompoundDetails;
